<script>
export default {
  name: 'date',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      showPopup: this.value,
      minDate: null,
      maxDate: null,
      currentDate: null,
    }
  },
  watch:{
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
  },
  created() {
    // 当前日期往前增加1个月
    this.minDate = new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate());
    // 当前日期往后增加1个月
    this.maxDate = new Date(new Date().getFullYear(),new Date().getMonth()+1,new Date().getDate());
    // 当天日期
    this.currentDate = new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate());
  },
  methods: {
    onCancel(){
      this.showPopup = false;
    },
    onConfirm(values){
      // 创建 Date 对象
      const date = new Date(values);
      // 获取年、月、日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
      const day = String(date.getDate()).padStart(2, '0');
      // 组合成 yyyy-mm-dd 格式
      this.itemObj.dateValue = `${year}-${month}-${day}`;
      this.itemObj.value = new Date(values);
      this.$emit('submit', this.itemObj);
      this.onCancel();
    }
  }
}
</script>
<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
  >
    <van-datetime-picker
        show-toolbar
        v-if="itemObj.params&&itemObj.params.customDesign"
        type="date"
        :title="itemObj.name"
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
    />
  </van-popup>
</template>
<style scoped lang="scss">
</style>